module.exports = __webpack_public_path__ + "6c8b8df615b139b84e01ab04d8ae4083.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-46.png
// module id = 128
// module chunks = 0